import globalCacheManager from './globalCacheManager';

const CACHE_KEY = 'attachmentImage';

class AttachmentImageCache {
  constructor() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  /**
   * Bundle에서 mes + permissions 설정 (notice 제외)
   */
  setFromBundle({ mes, permissions }) {
    this.data = {
      mes: mes ?? {},
      permissions: permissions ?? {},
    };
    this.lastFetchTime = Date.now();
  }

  /**
   * @param {boolean} forceRefresh
   * @returns {Promise<Object>}
   */
  async fetchData(forceRefresh = false) {
    if (!forceRefresh && this.data) {
      return this.data;
    }

    if (this.pendingPromise) {
      return this.pendingPromise;
    }

    this.pendingPromise = (async () => {
      try {
        await globalCacheManager.refreshFromBundle(forceRefresh);
        return this.data || {};
      } catch (error) {
        console.error('[AttachmentImageCache] Error refreshing from bundle:', error);
        return this.data || {};
      } finally {
        this.pendingPromise = null;
      }
    })();

    return this.pendingPromise;
  }

  getData() {
    return this.data;
  }

  invalidate() {
    this.data = null;
    this.pendingPromise = null;
    this.lastFetchTime = null;
  }

  getLastFetchTime() {
    return this.lastFetchTime;
  }
}

const attachmentImageCache = new AttachmentImageCache();

globalCacheManager.register(CACHE_KEY, attachmentImageCache);

export const fetchAttachmentImageDataCached = async (forceRefresh = false) => {
  return await attachmentImageCache.fetchData(forceRefresh);
};

export const getAttachmentImageDataCached = () => {
  return attachmentImageCache.getData();
};

export const invalidateAttachmentImageCache = () => {
  attachmentImageCache.invalidate();
};

export default attachmentImageCache;
